(function () {
	'use strict';
	var controllerId = 'userAdd';

	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'ruoli', userAdd]);

    function userAdd($scope, $uibModalInstance, datacontext, ruoli) {
        $scope.ruoli = ruoli;        
	    $scope.user = {};
	    $scope.user.Attivato = true;		
        $scope.user.Password = 'Temp' + new Date().getFullYear();                      
        $scope.user.CambioPwd = true;
        $scope.user.ruolo = 2;
		$scope.aziende = getAziende();

		$scope.ok = function (isValid) {
            if (isValid) {
                 $scope.user.Roles = [];
                 $scope.user.Roles.push({ 'Id': $scope.user.ruolo });

				var result = addItem($scope.user)
				$uibModalInstance.close(result);
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};		

		function addItem(item) {
			item.DtAttivazione = new Date();
			return datacontext.user_add(item).then(function (data) {			    
			    if (!data || data.Id == null || data.Id == 0) return null;
                
			    return data;
			});
		}

		function getAziende() {
			return datacontext.azienda_getAllList().then(function (data) {
				return $scope.aziende = data;
			});
        }
	}
})();